export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/v4/like/icon-like-b43ca972f5518579c58f5ca433d1fd8d.svg";